export default __webpack_public_path__ + "static/media/live.2a2a279d.svg";